import { guid } from 'src/core/classes/helpers/GuidHelper'

export const getUserLanguage = () => {
  return navigator?.language
}

export const getUserId = () => {
  return localStorage.getItem('_hp_survey_user_id') || ''
}

export const setUserId = () => {
  const id = guid()
  localStorage.setItem('_hp_survey_user_id', id)
}
